const adminActivityRouter = [
  {
    path: '/admin/activity',
    name: 'AdminActivityIndex',
    component: () => import('@/views/admin/activity/index')
  },
  {
    path: '/admin/activity/create',
    name: 'AdminActivityCreate',
    component: () => import('@/views/admin/activity/create')
  },
  {
    path: '/admin/activity/edit',
    name: 'AdminActivityEdit',
    component: () => import('@/views/admin/activity/edit')
  },
  {
    path: '/admin/activity/link',
    name: 'AdminActivityLink',
    component: () => import('@/views/admin/activity/link')
  },
  {
    path: '/admin/activity/picture',
    name: 'AdminActivityPictureIndex',
    component: () => import('@/views/admin/activity/picture/index')
  },
  {
    path: '/admin/activity/picture/create',
    name: 'AdminActivityPictureCreate',
    component: () => import('@/views/admin/activity/picture/create')
  }
]

export default adminActivityRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/activity.js